<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Customer Mailchimp Groups</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="alert alert-info" *ngIf="orgMailchimpGroupCategories.length === 0">
      No Mailchimp groups configured.
    </div>

    <div class="form-group" *ngFor="let groupCategory of orgMailchimpGroupCategories">
      <label>
        {{ groupCategory.name }}
        <ng-container *ngIf="groupCategory.group_type === MailchimpGroupCategoryType.hidden">(Hidden)</ng-container>
      </label>

      <!--suppress TypeScriptValidateTypes -->
      <ng-container *ngIf="[MailchimpGroupCategoryType.checkboxes, MailchimpGroupCategoryType.hidden].includes(groupCategory.group_type)">
        <div class="form-check" *ngFor="let group of groupCategory.groups">
          <input class="form-check-input" type="checkbox"
                 name="checkbox{{ group.id }}" id="checkbox{{ group.id }}"
                 [checked]="selectedGroupIds.includes(group.id)"
                 (click)="toggleGroupInclusive(group.id)">
          <label class="form-check-label" for="checkbox{{ group.id }}">
            {{ group.name }}
          </label>
        </div>
      </ng-container>
      <ng-container *ngIf="groupCategory.group_type === MailchimpGroupCategoryType.radio">
        <div class="form-check">
          <input class="form-check-input" type="radio"
                 name="radio{{ groupCategory.id }}" id="radio{{ groupCategory.id }}null"
                 [checked]="noneSelectedForGroupCategory(groupCategory)"
                 (click)="selectGroupExclusive(null, groupCategory)">
          <label class="form-check-label text-muted" for="radio{{ groupCategory.id }}null">
            None
          </label>
        </div>
        <div class="form-check" *ngFor="let group of groupCategory.groups">
          <input class="form-check-input" type="radio"
                 name="radio{{ groupCategory.id }}" id="radio{{ groupCategory.id }}{{ group.id }}"
                 [checked]="selectedGroupIds.includes(group.id)"
                 (click)="selectGroupExclusive(group.id, groupCategory)">
          <label class="form-check-label" for="radio{{ groupCategory.id }}{{ group.id }}">
            {{ group.name }}
          </label>
        </div>
      </ng-container>
      <ng-container *ngIf="groupCategory.group_type === MailchimpGroupCategoryType.dropdown">
        <select class="custom-select" name="select{{ groupCategory.id }}"
                (change)="selectGroupExclusive($event.target['value'], groupCategory)">
          <option [value]="null" class="text-muted">None</option>
          <option *ngFor="let group of groupCategory.groups"
                  [value]="group.id"
                  [selected]="selectedGroupIds.includes(group.id)">
            {{ group.name }}
          </option>
        </select>
      </ng-container>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
